"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rendall API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TicketTagTypeToJSON = exports.TicketTagTypeFromJSONTyped = exports.TicketTagTypeFromJSON = exports.TicketTagType = void 0;
/**
 *
 * @export
 */
exports.TicketTagType = {
    SiteDeletionRequest: 'site_deletion_request',
    ReadinessIrTabletopReq: 'readiness_ir_tabletop_req',
    ReadinessIrPlannerReq: 'readiness_ir_planner_req',
    ReadinessIrCraReq: 'readiness_ir_cra_req',
    AwirCaseIntakeOther: 'awir_case_intake_other',
    AwirCaseIntakeUnknown: 'awir_case_intake_unknown',
    AwirBecCaseIntake: 'awir_bec_case_intake',
    AwirRansomwareCaseIntake: 'awir_ransomware_case_intake'
};
function TicketTagTypeFromJSON(json) {
    return TicketTagTypeFromJSONTyped(json, false);
}
exports.TicketTagTypeFromJSON = TicketTagTypeFromJSON;
function TicketTagTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.TicketTagTypeFromJSONTyped = TicketTagTypeFromJSONTyped;
function TicketTagTypeToJSON(value) {
    return value;
}
exports.TicketTagTypeToJSON = TicketTagTypeToJSON;
